import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/lesseeUser/selectList',
    method: 'get',
    params: data,
  });
}

export function remove(param) {
  return request({
    url: '/lesseeUser/' + param,
    method: 'delete',
  });
}
export function resetAppletPassword (data) {
  return request({
		url: '/lesseeUser/resetAppletPassword' ,
		params: data,
  });
}
